import FlagButton from "../../../Buttons/FlagButton/FlagButton";
import {stockListScreenUrl} from "../../../../Route_urls";
import React from "react";
import Spacer from "../../../Spacer";

const DiscoverStocks = () => {

    return (
        <>
            <Spacer axis="vertical" size={30}/>

            <h1 className="mb-4 text-2xl text-center	 font-extrabold leading-none tracking-tight text-gray-900 md:text-5xl lg:text-4xl dark:text-white">Discover
                stocks from different countries</h1>
            <p className="mb-6 text-lg text-center	 font-normal text-gray-500 lg:text-xl sm:px-16 xl:px-48 dark:text-gray-400">Browse
                all stocks in selected countries</p>
            <Spacer axis="vertical" size={10}/>

            <div className="text-center	">
                <div style={{"margin": "15px"}}>
                    <FlagButton buttonText='United States' buttonCountryName='united-states' url={stockListScreenUrl}
                                queryCountryNameFilter={"united-states"}/>
                </div>
                <div style={{"margin": "15px"}}>

                    <FlagButton buttonText='Sweden' buttonCountryName='sweden' url={stockListScreenUrl}
                                queryCountryNameFilter={"sweden"}/>
                </div>
                <div>
                    <FlagButton buttonText='Germany' buttonCountryName='germany' url={stockListScreenUrl}
                                queryCountryNameFilter={"germany"}/>

                </div>
                <div style={{"margin": "15px"}}>

                    <FlagButton buttonText='France' buttonCountryName='france' url={stockListScreenUrl}
                                queryCountryNameFilter={"france"}/>
                </div>
            </div>
            <Spacer axis="vertical" size={150}/>

        </>
    )
}

export default DiscoverStocks